import {useAuthUserStore} from "@/stores/auth";

export default {
    index(academyUuid) {

        return useAuthUserStore().getApiClient.get('/reports/sales/annual', {
            params: {
                academy_uuid: academyUuid
            }
        })
    }
}